import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { ProvinceCreateForm } from "@/features/province/ProvinceCreateForm";

export function ProvinceCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/province",
            label: "Province",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add Province</H2>
      <ProvinceCreateForm />
    </>
  );
}
